module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/NIGHTFALL_STYLE.8448c49f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/NIGHTFALL_STYLE.png
// module id = 1166
// module chunks = 16